import React from 'react'

const Footer = () => {
    return (
        <div className='front-footer'>
            COPYRIGHT © 2023 | ARAFAT RONY
        </div>
    )
}

export default Footer